import { callKakaostyleMktFunction } from '../../callKakaostyleMktFunction';

export const logFirebase = (eventName: string, parameters?: object) => {
  callKakaostyleMktFunction('logFirebase', eventName)(parameters);
};
